'use client';

import { cssSpacing } from "../../styles/index.mjs";
import { TypeList } from "../TypeList/index.mjs";
import styled from "../../styled-components.mjs";
/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsList component with instead.
 */
export var NavPillList = styled(TypeList).attrs({
  condensedAll: true,
  listStyleReset: true,
  role: 'tablist'
}).withConfig({
  displayName: "NavPillList",
  componentId: "sc-1du852g-0"
})(["&::after{clear:both;content:'';display:table;}margin-block-end:", ";text-align:center;overflow-wrap:break-word;"], cssSpacing('looser-3', '48px'));